(function () {
  function initMixBundle(root) {
    if (!root || root.dataset.mixBundleInit === 'true') return;
    root.dataset.mixBundleInit = 'true';

    const productDetails = root.closest('.product-details');
    const buyButtons = productDetails?.querySelector('.buy-buttons-block');
    const dataEl = root.querySelector('[data-elite-mix-bundle-data]');
    const picker = root.querySelector('[data-elite-mix-picker]');
    if (!dataEl) return;

    let catalog = [];
    try {
      catalog = JSON.parse(dataEl.textContent);
    } catch {
      return;
    }

    const currentVariantId = Number(root.dataset.currentVariantId);
    const tierInputs = root.querySelectorAll('[data-elite-mix-tier]');
    const slotsRoot = root.querySelector('[data-elite-mix-slots]');
    const grid = root.querySelector('[data-elite-mix-grid]');
    const addBtn = root.querySelector('[data-elite-mix-add]');
    const slots = [];
    let requiredCount = 0;

    const findProduct = (variantId) => catalog.find((p) => p.variantId === variantId);

    const showPicker = (visible) => {
      if (!picker) return;
      picker.hidden = !visible;
      picker.classList.toggle('is-hidden', !visible);
    };

    const setBuyButtonsVisible = (visible) => {
      if (!buyButtons) return;
      buyButtons.classList.toggle('elite-mix-bundle__hide-atc', !visible);
    };

    const renderSlots = () => {
      if (!slotsRoot) return;
      slotsRoot.innerHTML = '';
      for (let i = 0; i < requiredCount; i += 1) {
        const slot = document.createElement('div');
        slot.className = 'elite-mix-bundle__slot';
        const item = slots[i];
        if (item) {
          slot.innerHTML = `
            <img src="${item.image}" alt="" width="48" height="48" loading="lazy">
            <div class="elite-mix-bundle__slot-text">
              <strong>${item.title}</strong>
              <span>Tote ${i + 1}</span>
            </div>
            <button type="button" class="elite-mix-bundle__slot-clear" data-clear-slot="${i}" aria-label="Remove">×</button>
          `;
        } else {
          slot.classList.add('elite-mix-bundle__slot--empty');
          slot.innerHTML = `<span>Pick tote ${i + 1} below</span>`;
        }
        slotsRoot.appendChild(slot);
      }

      slotsRoot.querySelectorAll('[data-clear-slot]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const index = Number(btn.dataset.clearSlot);
          slots[index] = null;
          renderSlots();
          renderGrid();
          updateAddButton();
        });
      });
    };

    const renderGrid = () => {
      if (!grid) return;
      grid.innerHTML = catalog
        .map((product) => {
          const isSelected = slots.some((s) => s && s.variantId === product.variantId);
          const disabled = !product.available ? ' disabled' : '';
          return `
            <button
              type="button"
              class="elite-mix-bundle__pick${isSelected ? ' is-selected' : ''}"
              data-pick-variant="${product.variantId}"
              ${disabled}
            >
              <img src="${product.image}" alt="" width="72" height="72" loading="lazy">
              <span>${product.title}</span>
            </button>
          `;
        })
        .join('');

      grid.querySelectorAll('[data-pick-variant]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = Number(btn.dataset.pickVariant);
          const product = findProduct(variantId);
          if (!product || !product.available) return;

          const existing = slots.findIndex((s) => s && s.variantId === variantId);
          if (existing >= 0) {
            slots[existing] = null;
            renderSlots();
            renderGrid();
            updateAddButton();
            return;
          }

          const emptyIndex = slots.findIndex((s) => !s);
          if (emptyIndex === -1) return;
          slots[emptyIndex] = product;
          renderSlots();
          renderGrid();
          updateAddButton();
        });
      });
    };

    const updateAddButton = () => {
      if (!addBtn) return;
      const filled = slots.filter(Boolean).length;
      const ready = filled === requiredCount;
      addBtn.disabled = !ready;
      addBtn.textContent = ready
        ? requiredCount === 2
          ? 'Add 2 totes to cart'
          : 'Add 3 totes to cart'
        : `Select ${requiredCount - filled} more tote${requiredCount - filled === 1 ? '' : 's'}`;
    };

    const setTier = (count) => {
      requiredCount = count;
      slots.length = count;
      for (let i = 0; i < count; i += 1) {
        slots[i] = null;
      }
      if (currentVariantId) {
        const current = findProduct(currentVariantId);
        if (current) slots[0] = current;
      }

      showPicker(true);
      setBuyButtonsVisible(false);
      renderSlots();
      renderGrid();
      updateAddButton();
    };

    tierInputs.forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        setTier(Number(input.value));
      });
    });

    if (addBtn) {
      addBtn.addEventListener('click', async () => {
        const items = slots.filter(Boolean).map((p) => ({ id: p.variantId, quantity: 1 }));
        if (items.length !== requiredCount) return;

        addBtn.disabled = true;
        addBtn.textContent = 'Adding…';

        try {
          const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          if (!res.ok) throw new Error('Cart error');
          window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch {
          addBtn.textContent = 'Try again';
          addBtn.disabled = false;
        }
      });
    }

    showPicker(false);
    setBuyButtonsVisible(true);
  }

  function initAll() {
    document.querySelectorAll('[data-elite-mix-bundle]').forEach(initMixBundle);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-elite-mix-bundle]').forEach(initMixBundle);
  });
})();
